import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationHomeBusiness: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3773_11537"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3773_11537)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M184.327 37.252l45.398 61.14M173.344 37.252l-45.397 61.14"
        ></path>
        <rect
          width="162.946"
          height="105.833"
          x="97"
          y="94.168"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="2"
        ></rect>
        <rect
          width="129.264"
          height="72.151"
          x="113.841"
          y="111.01"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="2"
        ></rect>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="square"
          strokeLinejoin="bevel"
          strokeWidth="4"
          d="M97.194 94.365l16.475 16.475M243.271 183.33l15.743 15.743M259.746 94.365l-16.109 16.109M113.669 183.33l-16.475 16.475"
        ></path>
        <circle
          cx="178.469"
          cy="36.519"
          r="7.519"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <path
          fill={colors.primary[500]}
          d="M152.185 147.084c0-6.092-2.226-9.138-6.678-9.138-4.451 0-6.677 3.046-6.677 9.138 0 6.092 2.226 9.138 6.677 9.138 4.452 0 6.678-3.046 6.678-9.138zm1.863 9.701c-2.085 2.319-4.932 3.479-8.541 3.479-3.608 0-6.466-1.16-8.575-3.479-2.086-2.32-3.128-5.554-3.128-9.701s1.042-7.381 3.128-9.7c2.109-2.32 4.967-3.48 8.575-3.48 3.609 0 6.456 1.16 8.541 3.48 2.109 2.319 3.163 5.553 3.163 9.7 0 4.147-1.054 7.381-3.163 9.701zM166.046 138.262v8.471c0 .164.094.269.281.316.891.117 1.758.176 2.601.176 1.898 0 3.339-.41 4.323-1.23 1.008-.844 1.512-2.039 1.512-3.585 0-3.117-1.945-4.675-5.835-4.675-.843 0-1.71.059-2.601.176-.187.047-.281.164-.281.351zm-2.882 21.651c-.539 0-1.007-.199-1.406-.598a1.983 1.983 0 01-.562-1.406v-21.474c0-.563.187-1.066.562-1.511a1.993 1.993 0 011.406-.739 61.712 61.712 0 015.764-.281c3.515 0 6.151.703 7.908 2.109 1.757 1.383 2.636 3.398 2.636 6.045 0 2.929-.855 5.143-2.566 6.643-1.687 1.5-4.194 2.249-7.521 2.249-.773 0-1.792-.047-3.058-.14-.187 0-.281.093-.281.281v6.818c0 .539-.199 1.008-.597 1.406-.399.399-.867.598-1.406.598h-.879zM185.269 159.913c-.539 0-1.008-.199-1.406-.598-.398-.398-.598-.867-.598-1.406v-21.65c0-.539.2-1.007.598-1.406.398-.398.867-.597 1.406-.597h11.95c.539 0 1.007.199 1.405.597.399.399.598.867.598 1.406 0 .539-.199 1.008-.598 1.406a1.98 1.98 0 01-1.405.562h-8.717c-.211 0-.316.106-.316.317v5.658c0 .211.105.317.316.317h8.119c.539 0 .984.187 1.336.562.375.375.562.82.562 1.335 0 .516-.187.961-.562 1.336-.352.351-.797.527-1.336.527h-8.119c-.211 0-.316.106-.316.317v7.029c0 .211.105.316.316.316h8.717c.539 0 1.007.199 1.405.598.399.375.598.831.598 1.37 0 .539-.199 1.008-.598 1.406-.398.399-.866.598-1.405.598h-11.95zM206.376 159.913c-.538 0-1.007-.199-1.405-.598a1.984 1.984 0 01-.563-1.406v-21.65c0-.539.188-1.007.563-1.406.398-.398.867-.597 1.405-.597h.774c1.335 0 2.319.586 2.952 1.757l8.681 15.675c0 .024.012.036.035.036.024 0 .035-.012.035-.036v-15.429c0-.539.2-1.007.598-1.406.398-.398.867-.597 1.406-.597h.773c.539 0 .996.199 1.371.597.398.399.597.867.597 1.406v21.65c0 .539-.199 1.008-.597 1.406a1.81 1.81 0 01-1.371.598h-.773c-1.336 0-2.32-.586-2.953-1.758l-8.681-15.675c0-.023-.011-.035-.035-.035-.023 0-.035.012-.035.035v15.429c0 .539-.199 1.008-.597 1.406-.399.399-.867.598-1.406.598h-.774z"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationHomeBusiness;
